import styled from 'styled-components'

export const Small = styled.small`
  font-size: 0.75em;
  margin-top: 20px;
  display: block;
  line-height: 1.3;
  -webkit-font-smoothing: antialiased;
`

export const Note = styled.div`
  position: absolute;
  top: 0;
  color: var(--text-color);
  font-size: 0.75em;
  line-height: 1.2;
  width: 150px;
  -webkit-font-smoothing: antialiased;

  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 0.65em;
    width: 80px;
  }
`

export const Tick = styled.line`
  // stroke: ${({ theme }) => `rgb(${theme.textColorOnBackground})`};
  stroke: var(--text-color);
  stroke-width: 1.25px;
  opacity: 0.75;
`

export const Label = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  color: var(--text-color);
  transform: translate(-50%, -50%);
  font-size: 0.65em;
  line-height: 1.1;
  font-weight: bold;
`

export const ChartTitle = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  color: var(--text-color);
  transform: translate(-50%, -50%);
  font-size: 0.75em;
  line-height: 1.1;
  font-weight: bold;
`

export const ContentWidth = styled.div`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  position: relative;

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: calc(100% - 30px);
    margin: 0 15px;
  }
`

export const GridLine = styled.line`
  stroke: ${({ theme }) => theme.greyLight};
  stroke-width: 1px;
`

export const Strong = styled.strong<{ color?: string }>`
  color: ${({ theme, color }) =>
    `rgb(${color === 'yellow' ? theme.yellowColor : theme.greenColor})`};
  font-family: var(--font-sans-serif);
  background: ${({ theme, color }) =>
    `rgb(${color === 'yellow' ? theme.yellowColor : theme.greenColor}, 0.2)`};
`
export const StepContent = styled.div`
  max-width: 300px;
  padding: 15px;
  background: ${({ theme }) => theme.backgroundColor};
  line-height: 1.5;
  font-family: var(--font-serif);
  font-size: 0.95em;
  -webkit-font-smoothing: antialiased;

  ${({ theme }) => theme.breakpoints.up('xxl')} {
    transform: translateX(-65%);
  }

  ${({ theme }) => {
    //@ts-ignore
    return theme.breakpoints.up('xxxl')
  }} {
    transform: translateX(-100%);
  }

  p:first-child {
    margin-top: 0;
  }
`

export const StepContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding-bottom: 90vh;
`
